import {
  backend_chat_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const getAllChatMessage = async (workOrderId = "", offset=0,limit=10) => {

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_chat_url + `v1/chat/conversation/${workOrderId}/messages?limit=${limit}&offset=${offset}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};

export const getWorkOrderChatPeople = async (workOrderId = "") => {

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_chat_url + `v1/chat/conversation/${workOrderId}/members`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};

export const addPeopleToChat = async (workOrderId = "", newMemberIds) => {
const params = {
  newMemberIds
}
  try {
    const response = await uninterceptedAxiosInstance.put(
      backend_chat_url + `v1/chat/conversation/${workOrderId}/members`,
      {newMemberIds},
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};
